import React, { useEffect, useRef, useState } from 'react';
import { Animated, Platform, StyleSheet, View } from 'react-native';

import { IconMoney, tokens } from '@fhs/ui';

export function BalanceIcon({ animate }: { animate: boolean }) {
  const scaleAnim = useRef(new Animated.Value(0)).current;
  const colorAnim = useRef(new Animated.Value(0)).current;
  const [iconColor, setIconColor] = useState<string>(tokens.colors.$houseDark);

  useEffect(() => {
    // Listen to color animation changes to update icon color, that is the way we found for svgs
    const colorListener = colorAnim.addListener(({ value }) => {
      if (value < 0.5) {
        setIconColor(tokens.colors.$houseDark);
      } else {
        setIconColor(tokens.colors.$white);
      }
    });
    return () => colorAnim.removeListener(colorListener);
  }, [colorAnim]);

  useEffect(() => {
    if (animate) {
      Animated.parallel([
        Animated.timing(scaleAnim, {
          toValue: 1,
          duration: 400,
          useNativeDriver: Platform.OS !== 'web',
        }),
        Animated.timing(colorAnim, {
          toValue: 1,
          duration: 400,
          useNativeDriver: Platform.OS !== 'web',
        }),
      ]).start(() => {
        setTimeout(() => {
          Animated.parallel([
            Animated.timing(scaleAnim, {
              toValue: 0,
              duration: 400,
              useNativeDriver: Platform.OS !== 'web',
            }),
            Animated.timing(colorAnim, {
              toValue: 0,
              duration: 400,
              useNativeDriver: Platform.OS !== 'web',
            }),
          ]).start();
        }, 4600);
      });
    }
  }, [animate, scaleAnim, colorAnim]);

  const backgroundColor = colorAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [tokens.colors.$blackOpacity10, tokens.colors.$success],
  });

  return (
    <View style={styles.iconWrapper}>
      <Animated.View
        style={[
          styles.animatedCircle,
          {
            backgroundColor,
            transform: [{ scale: scaleAnim }],
          },
        ]}
      />
      <View style={styles.iconAbsolute}>
        <IconMoney size={24} color={iconColor} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  iconWrapper: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  animatedCircle: {
    position: 'absolute',
    width: 50,
    height: 50,
    borderRadius: 25,
    zIndex: 1,
  },
  iconAbsolute: {
    zIndex: 2,
  },
});
